import { useAgentActivity } from "./AgentActivityContext";
import { TypingIndicator } from "./TypingIndicator";
import { useActivitySteps } from "./useActivitySteps";

export function PendingIndicator() {
  const activities = useAgentActivity();
  const steps = useActivitySteps();

  if (steps.length > 0) return null;

  const running = activities.find((activity) => activity.status === "running");
  return <TypingIndicator label={running?.title} />;
}
